<div class="sleeknote-wrapper {{sleeknotes[0].Theme}}" *ngIf="sleeknotes.length > 0 && priorityNotes.length === 0 && loginNotes.length === 0">
    <div class="header">
        <div class="header-icon" (click)="close('sleek');"></div>
    </div>
    <div class="headline text-center {{sleeknotes[0].Theme}}">
        {{sleeknotes[0].Headline}}
    </div>
    <div class="text text-center {{sleeknotes[0].Theme}}">
        <div [innerHtml]="sleeknotes[0].Text">
        </div>
        <div *ngIf="sleeknotes[0].CtaType !== 'none'">
            <div class="cta" (click)="onCtaClick(sleeknotes[0], 'sleek')">{{sleeknotes[0].CtaText}}</div>
        </div>
    </div>
</div>
<div class="sleeknote-wrapper {{loginNotes[0].Theme}}" *ngIf="loggedIn && loginNotes.length > 0 && priorityNotes.length === 0">
    <div class="header">
        <div class="header-icon" (click)="close('login');"></div>
    </div>
    <div class="headline text-center {{loginNotes[0].Theme}}">
        {{loginNotes[0].Headline}}
    </div>
    <div class="text text-center {{loginNotes[0].Theme}}">
        <div [innerHtml]="loginNotes[0].Text">
        </div>
        <div *ngIf="loginNotes[0].CtaType !== 'none'">
            <div class="cta" (click)="onCtaClick(loginNotes[0], 'login')">{{loginNotes[0].CtaText}}</div>
        </div>
    </div>
</div>
<div class="sleeknote-wrapper {{priorityNotes[0].Theme}}" *ngIf="priorityNotes.length > 0" >
    <div class="header">
        <div class="header-icon" (click)="close('priority');"></div>
    </div>
    <div class="headline text-center {{priorityNotes[0].Theme}}">
        {{priorityNotes[0].Headline}}
    </div>
    <div class="text text-center {{priorityNotes[0].Theme}}">
        <div [innerHtml]="priorityNotes[0].Text">
        </div>
        <div *ngIf="priorityNotes[0].CtaType !== 'none'">
            <div class="cta" (click)="onCtaClick(priorityNotes[0], 'priority')">{{priorityNotes[0].CtaText}}</div>
        </div>
    </div>
</div>
